export default "__VITE_ASSET__tlPpPggE__"